import { ProductUnitItemResponse } from '@/types/service-response'

export class ProductUnit {
  public constructor (
    readonly id: number,
    readonly code: string,
    readonly text: string
  ) {}

  static createListFromResponse (responseData: ProductUnitItemResponse[]): Array<ProductUnit> {
    let result: Array<ProductUnit> = []
    if (responseData) {
      result = responseData.map((item: ProductUnitItemResponse ) => {
        return new ProductUnit(
          item.ID,
          item.Code ? item.Code : '',
          item.Bezeichnung ? item.Bezeichnung : ''
        )
      })
    }
    return result
  }
}
